module.exports = __webpack_public_path__ + "img/DSC_09985_6ae3f52230.bd3adc63.webp";